import * as CollapsiblePrimitive from "@radix-ui/react-collapsible"

export const Collapsible = CollapsiblePrimitive.Root

export const { CollapsibleTrigger, CollapsibleContent } = CollapsiblePrimitive
